import { ChartOptionsProvider, CHART_FLEXED_COLOUR, CHART_FLEXED_MARKER } from './chart-options';
import { Injectable } from '@angular/core';

@Injectable()
export class WciOptionsProvider extends ChartOptionsProvider {
    public getOptions(company, flexedData = {}, flexed = false) {
        let chartOptions;
        const wciForecast = company.platformData.wciForecast,
            wciHistoric = company.platformData.wciHistoric.filter(w => w.value !== null),
            flexedWci = flexedData['valueDrivers'] ? flexedData['valueDrivers']['wci'] : [],
            minWci = Math.min(...wciHistoric.map(item => item.value * 100));
            const wciHistoricPercent = (wciHistoric[wciHistoric.length - 1].value*100).toFixed(1);

        chartOptions = {
          chart: Object.assign(this.defaultChartOptions.chart,{spacingBottom: 80}),
          credits: {
              enabled: true,
              text: `Trailing WCI: ${wciHistoricPercent}%`,
              style: {
                color: "#333",
                cursor: "pointer",
                fontSize: "12px"
              },
              position: {
                align: 'left',
                verticalAlign: 'bottom',
                x: 10,
                y: -20
              }
            },
            title: 'Working Capital Intensity (%)',
            legend: this.defaultChartOptions.legend,
            xAxis: {
                categories: [
                    wciHistoric.map(item => item.Year),
                    wciForecast.map(item => item.year)
                ]
            },
            yAxis: {
            labels:{
                x:0
            },
              min: Math.min(0, minWci),
                title: {
                    text: null
                }
            },
            tooltip: this.defaultChartOptions.tooltip,
            series: [
                {
                    name: 'Historic',
                    data: wciHistoric.map(item => [item.year, item.value * 100]),
                    visible: true
                },
                {
                    name: 'Forecast',
                    data: wciForecast.map(item => [item.year, item.value * 100]),
                    visible: true
                }]
        }
        if (flexed) {
            chartOptions.series.push(
                {
                name: 'Flexed Values',
                data: flexedWci.map(item => [item.year, item.value * 100]),
                visible: true,
                color: CHART_FLEXED_COLOUR,
                marker: {
                  symbol: CHART_FLEXED_MARKER
                }
            });
        }
        chartOptions = this.setYMax(chartOptions);
        chartOptions = this.setYMin(chartOptions);
        return super.getOptions(company, chartOptions);
    };
}



// WEBPACK FOOTER //
// ./src/providers/chart-options/wci.ts